var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"redo",attrs:{"viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M18 7.762v-7.762l12 12-12 12v-7.932c-13.961-0.328-13.362 9.493-9.808 15.932-8.772-9.482-6.909-24.674 9.808-24.238z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }